<template>
  <RenderPreview :component="component"></RenderPreview>
</template>
<script>
import RenderPreview from './components/RenderPreview.vue'

export default {
  name: 'PreviewComponents',

  components: {
    RenderPreview,
  },

  props: {
    component: {
      type: Object,
      required: true,
    },
  },
}
</script>
